import { Divider } from "@mantine/core"

const MantineDivider = (props: any) => {
    const { color, label, labelPosition, orientation, size, my, className } = props

    return <Divider my={my} label={label} color={color} labelPosition={labelPosition} orientation={orientation} className={className}/>
}
export default MantineDivider;